import { BaseEvent } from './base-event';
export class PlotAreaLeaveEvent extends BaseEvent {
}
